import React, { useState } from "react";
import { Form, Button, Card, Icon } from "semantic-ui-react";
import { useFormik } from "formik";
import { initialValues, validationSchema } from "./ClaseForm.form";
import { InstitutionApi } from "../../../../api"; // Importa el servicio API
import { useTranslation } from "react-i18next";
import "./ClaseForm.scss";

const institutionApi = new InstitutionApi();

export function ClaseForm({ user, onReload, close, accessToken }) {
  const { t } = useTranslation(["teachers", "common"]);
  const [classList, setClassList] = useState([]); // Estado para almacenar las clases añadidas
  const [newClass, setNewClass] = useState(""); // Input temporal para nueva clase

  const formik = useFormik({
    initialValues: initialValues(),
    validationSchema: validationSchema(t),
    onSubmit: async (values) => {
      try {
        const formData = new FormData();

        // Agregar clases del formulario
        classList.forEach((item) => {
          formData.append("classnumber", item);
        });

        console.log("FormData enviado:");
        for (let pair of formData.entries()) {
          console.log(pair[0], pair[1]);
        }

        // Enviar la petición PATCH al backend
        await institutionApi.updateInstitutionClassnumber(
          accessToken,
          user.user.institutions[0],
          formData,
        );

        onReload(); // Recargar datos después de registrar
        close(); // Cierra el modal
        console.log("Clases registradas exitosamente.");
      } catch (error) {
        console.error("Error al enviar clases:", error);
      }
    },
  });

  const handleAddClass = () => {
    if (newClass.trim()) {
      setClassList([...classList, newClass]); // Añadir nueva clase
      formik.setFieldValue("classnumber", [...classList, newClass]); // Actualizar Formik
      setNewClass(""); // Limpiar input
    }
  };

  const handleDeleteClass = (index) => {
    const updatedList = classList.filter((_, i) => i !== index);
    setClassList(updatedList);
    formik.setFieldValue("classnumber", updatedList); // Actualizar Formik
  };

  return (
    <Form className="clase-form" onSubmit={formik.handleSubmit}>
      <h3>{t("teachers:form.classRegisterTitle")}</h3>

      {/* Input para añadir nuevas clases */}
      <Form.Group className="fields">
        <Form.Input
          name="newClass"
          placeholder={t("teachers:form.classNamePlaceholder")}
          value={newClass}
          onChange={(e) => setNewClass(e.target.value)}
          className="field"
        />
        <Button type="button" icon primary onClick={handleAddClass}>
          <Icon name="plus" />
          {t("teachers:form.addClassButton")}
        </Button>
      </Form.Group>

      <Card.Group>
        {classList.map((item, index) => (
          <Card key={index} className="ui card">
            <Card.Content>
              <Card.Header>{item}</Card.Header>
              <Button
                icon="trash"
                color="red"
                size="small"
                onClick={() => handleDeleteClass(index)}
              />
            </Card.Content>
          </Card>
        ))}
      </Card.Group>

      <Button
        type="submit"
        primary
        fluid
        className="register-button"
        loading={formik.isSubmitting}
      >
        {t("common:actions.register")}
      </Button>
    </Form>
  );
}
